// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"styles_searchInput__-ZSmN","selectedInput":"styles_selectedInput__3r_go"};